export const filterModalTheme = {
   light: {
      filterHeader: {
         backgroundColor: 'bg-base-white',
         title: {
            color: 'text-gray-800'
         },
         description: {
            color: 'text-gray-600'
         },
         borderColor: 'border-gray-300'
      },
      filterLeftPane: {
         backgroundColor: 'bg-gray-100'
      },
      filterConditions: {
         backgroundColor: 'bg-base-white'
      }
   },
   dark: {}
}
